import React from 'react';
import { QNA_STATUS, QNA_STATUS_LABELS } from '../../platform/qnaConstants';
import './QnAStatusTag.css';

function QnAStatusTag({ status, className = '' }) {
  const normalized = status || QNA_STATUS.OPEN;
  const label = QNA_STATUS_LABELS[normalized] || QNA_STATUS_LABELS[QNA_STATUS.OPEN];

  return (
    <span className={`qna-status-tag qna-status-tag--${normalized} ${className}`.trim()}>
      {label}
    </span>
  );
}

export default QnAStatusTag;
